var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-group', {
    class: _vm.formGroupClass
  }, [_c('validation-provider', {
    attrs: {
      "name": _vm.labelName.toLowerCase(),
      "rules": _vm.rules
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (validationContext) {
        return [_vm.labelFor != '' ? [_c('label', {
          attrs: {
            "id": `label-${_vm.labelFor}`,
            "for": _vm.labelFor
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.computedLabel)
          }
        })])] : _vm._e(), _c('b-form-input', {
          class: _vm.computedInputClass,
          attrs: {
            "id": _vm.labelFor,
            "type": _vm.inputType,
            "state": _vm.getValidationState(validationContext, _vm.isErrorFlagSet),
            "aria-describedby": "input-feedback",
            "readonly": _vm.readonly,
            "placeholder": _vm.computedPlaceholder,
            "maxlength": _vm.maxLength
          },
          on: {
            "input": _vm.emitInputField
          },
          model: {
            value: _vm.computedInputData,
            callback: function ($$v) {
              _vm.computedInputData = $$v;
            },
            expression: "computedInputData"
          }
        }), !_vm.isErrorFlagSet ? _c('b-form-invalid-feedback', {
          class: `${_vm.labelFor}-feedback`,
          attrs: {
            "id": `${_vm.labelFor}-feedback`
          }
        }, [!_vm.computedInputData ? _c('div', [_vm._v(" " + _vm._s(_vm.customMessages) + " ")]) : validationContext.failedRules.email ? _c('div', [_vm._v(" " + _vm._s(_vm.customEmailMessage) + " ")]) : _c('div', [_vm._v(_vm._s(_vm.errorField ? _vm.errorField[0] : validationContext.errors[0]))])]) : _vm._e()];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }